// 🔧 Global fix for AntD Modal aria-hidden warning
export function applyModalAriaFix() {
  const observer = new MutationObserver(() => {
    const trapElements = document.querySelectorAll(
      'div[aria-hidden="true"][tabindex="0"][style*="width: 0px"]'
    );
    trapElements.forEach((el) => {
      el.removeAttribute('aria-hidden');
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect(); // return cleanup for useEffect
}